export const TIME_ZONE_METHODS = {
    USER_TIME_ZONE: 'USER_TIMEZONE',
    SPECIFIC_TIME_ZONE: 'specific_time_zone',
};
